import moment from "moment";
import { Client } from "../../clients/client";
import { Order } from "./models/Order";
import { OrderTable } from "./forms/OrderTableForm";
import { OrderUpdateDeliveryMode } from "./forms/OrderUpdateDeliveryModeForm";
import { Pagination, PaginationForm } from "@/common/mixins/pagination";

export class OrderUseCase {
  constructor(private client: Client) {}

  public async getDuplicateOrders(): Promise<Order[]> {
    return this.client.orders.getDuplicateOrders();
  }

  public async deleteRealDuplicateOrders(): Promise<Order[]> {
    return this.client.orders.deleteRealDuplicateOrders();
  }

  public presenterDataTable(orders: Order[]): OrderTable {
    return {
      headers: [
        { text: "MC Number", value: "mcNumber" },
        { text: "Shop", value: "name" },
        { text: "Source", value: "source" },
        { text: "Source Id", value: "sourceId" },
        { text: "Create Date", value: "useDate" },
        { text: "MC Status", value: "mcStatus" }
      ],
      orders: orders.map(order => {
        return {
          ...order,
          name: order.shop.name,
          useDate: moment(order.useDate)
            .utc()
            .format("DD/MM/YY HH:mm:ss")
        };
      }),
      selected: orders.filter(order => {
        return order.markDuplicate === true;
      })
    };
  }

  public markDuplicateOrders(orderTable: OrderTable) {
    const orderMarkIds: number[] = orderTable.selected!.map(selected => {
      return selected.id;
    });

    const orderUnmarkIds: number[] = orderTable
      .orders!.filter(order => {
        const orderFound = orderMarkIds.find(orderMarkId => {
          return order.id == orderMarkId;
        });
        return !orderFound;
      })
      .map(order => {
        return order.id;
      });

    return this.client.orders.patchDuplicateOrder({
      markOrderId: orderMarkIds,
      unmarkOrderId: orderUnmarkIds
    });
  }

  public async updateDeliveryModeByMcNumber(
    orderUpdateDeliveryMode: OrderUpdateDeliveryMode
  ): Promise<Order> {
    return this.client.orders.updateDeliveryMode(
      orderUpdateDeliveryMode.mcNumber,
      orderUpdateDeliveryMode.deliveryMode.id
    );
  }

  public async holdOrderByMcnumber(mcNumber: string): Promise<any> {
    return this.client.orders.holdOrder(mcNumber);
  }

  public async getHoldOrders(form: PaginationForm): Promise<Pagination<Order>> {
    return this.client.orders.getHoldOrdersList({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  public async cancelHoldOrderById(id: number): Promise<any> {
    return this.client.orders.cancelHoldOrderStatus(id);
  }

  public async reverseHoldOrderById(id: number): Promise<any> {
    return this.client.orders.reverseHoldOrderStatus(id);
  }

  public async updateOderMcStatus(mcNumber: string): Promise<any> {
    return this.client.orders.updateOderMcStatus(mcNumber);
  }
}
